import CrashIcon from "./CrashIcon"

export default  CrashIcon;
